import { render, staticRenderFns } from "./MSubmitSingleLink.vue?vue&type=template&id=43a7feba&lang=pug&"
import script from "./MSubmitSingleLink.vue?vue&type=script&lang=js&"
export * from "./MSubmitSingleLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports